export default "__VITE_ASSET__BMQeHne3__"